import React from "react"
import "../assets/css/sponsor.css"

export default function Sponsor() {
  return (
    <div>
      <div className="topic">
        <b>Collaborators</b>
      </div>

      <div className="tab-container">
        <div className="spe-img">
          <img
            src="https://f000.backblazeb2.com/file/hp-cloud/Conference/nserb+logo.png"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>
        <div className="sponsor-img">
          <img
            src="https://yt3.ggpht.com/ytc/AMLnZu9uaJOm2FF3SRle0wXBzjoPQPwG0VHX4i1bgnSJ=s900-c-k-c0x00ffffff-no-rj"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>
        <div className="sponsor-img">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdWKsUeUnfeHbjKASj3qZzQIrlq_MHh7Gl0eqvrwZDOg&s"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>
        <div className="spe-img">
          <img
            src="https://f000.backblazeb2.com/file/hp-cloud/Conference/acs.png"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>
        <div className="spe-img">
          <img
            src="https://f000.backblazeb2.com/file/hp-cloud/Conference/SPE+PDEU+Logo+With+White+Blue+Text.png"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>
        <div className="spe-img">
          <img
            src="https://f000.backblazeb2.com/file/hp-cloud/iadc.png"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>
        <div className="spe-img">
          <img
            src="https://f000.backblazeb2.com/file/hp-cloud/Conference/fipi.png"
            alt="sponsor"
            className="spon-img-css"
          />
        </div>

        {/* <div className="spe-img">
        <img
            src="https://f000.backblazeb2.com/file/hp-cloud/Conference/acs3.jpeg"
            alt="sponsor"
            className="spon-img-css"
          /></div> */}
        <div className="tabs"></div>
        <div className="tabs"></div>
        <div className="tabs"></div>
        <div className="tabs"></div>
        <div className="tabs"></div>
      </div>
    </div>
  )
}
